import {ajax} from '../utils/ajaxHelper';

const defaultGeoDistanceLocale = 'en_US_HA';

async function fetchGeoDistance({listingId, locale = defaultGeoDistanceLocale}) {
    return ajax(`/pdp/geoDistance?listingId=${listingId}&locale=${locale}`);
}

export {fetchGeoDistance, defaultGeoDistanceLocale};
